var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React from "react";
import Foundation from "@microsoft/fast-components-foundation-react";
import { Typography, TypographySize, } from "@microsoft/fast-components-react-msft";
import { Hypertext } from "@microsoft/fast-components-react-base";
import { typeRamp } from "@microsoft/fast-components-styles-msft";
import { Attribution } from "../attribution";
import { applyMaxLines } from "@microsoft/fast-jss-utilities";
import { classNames } from "@microsoft/fast-web-utilities";
import { memoize } from "lodash-es";
class PreviewCard extends Foundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            attribution: void 0,
            destination: void 0,
            icon: void 0,
            heading: void 0,
            height: void 0,
            image: void 0,
            imageOverlay: void 0,
            managedClasses: void 0,
            width: void 0,
        };
    }
    /**
     * Renders the component
     */
    render() {
        return (React.createElement("div", Object.assign({}, this.generateAttributes(), { className: this.generateClassNames() }),
            this.renderImage(),
            this.renderContentArea()));
    }
    /**
     * Generates class names
     */
    generateClassNames() {
        const { previewCard } = this.props.managedClasses;
        return super.generateClassNames(classNames(previewCard));
    }
    generateAttributes() {
        const attributes = Object.assign({}, this.unhandledProps());
        return Object.assign({}, attributes, { style: Object.assign({}, attributes.style, { height: this.props.height, width: this.props.width }) });
    }
    /**
     * Render image based on props
     */
    renderImage() {
        const { previewCard_imageRegion, previewCard_obscuredRegion, previewCard_image, } = this.props.managedClasses;
        if (typeof this.props.image === "function") {
            return (React.createElement("div", { className: classNames(previewCard_imageRegion, [
                    previewCard_obscuredRegion,
                    this.props.imageOverlay,
                ]) },
                this.props.image(classNames(previewCard_image)),
                this.generateIcon()));
        }
    }
    /**
     * Render content area based on props
     */
    renderContentArea() {
        return (React.createElement("div", { className: classNames(this.props.managedClasses.previewCard_contentRegion) },
            this.renderHeading(),
            this.renderAttribution()));
    }
    /**
     * Render the article title with destination
     */
    renderHeading() {
        const _a = this.getHeadingProps(), { children } = _a, headingProps = __rest(_a, ["children"]);
        const { previewCard_heading, previewCard_headingContent, previewCard_obscuredRegion, } = this.props.managedClasses;
        return (React.createElement(Hypertext, Object.assign({}, this.props.destination, { className: classNames(previewCard_heading, previewCard_obscuredRegion) }),
            React.createElement(Typography, Object.assign({}, headingProps, { jssStyleSheet: PreviewCard.generateHeadingMaxlines(headingProps.size), className: classNames(previewCard_headingContent) }), children)));
    }
    renderAttribution() {
        if (this.props.attribution) {
            return (React.createElement(Attribution, Object.assign({}, this.props.attribution, { className: classNames(this.props.managedClasses.previewCard_attribution) })));
        }
    }
    /**
     * Generates icon based on props
     */
    generateIcon() {
        if (typeof this.props.icon === "function") {
            const { previewCard_icon, previewCard_iconWrapper, } = this.props.managedClasses;
            return (React.createElement("span", { className: classNames(previewCard_iconWrapper) }, this.props.icon(classNames(previewCard_icon))));
        }
    }
    /**
     * Gets props for the heading and sets default props if needed
     */
    getHeadingProps() {
        return Object.assign({}, { size: TypographySize._7 }, this.props.heading);
    }
}
PreviewCard.defaultProps = {
    height: "77px",
    width: "300px",
    imageOverlay: true,
    managedClasses: {},
};
PreviewCard.displayName = "PreviewCard";
/**
 * Memoized function to get the heading stylesheet to avoid profileration of per-instance inline stylesheets.
 */
PreviewCard.generateHeadingMaxlines = memoize((headingSize) => ({
    typography: Object.assign({}, applyMaxLines(2, typeRamp[`t${headingSize}`].lineHeight)),
}), (...args) => args.join());
export default PreviewCard;
